<template>
    <div class="qualityTracking">
        质量追溯
    </div>
</template>

<script>
export default {
  name: "qualityTracking",
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
